export default function (id) {
  if (typeof id === 'object'){
    id = null
  }
  let window = id ? `blog-post.${id}` : 'blog-post.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Publicação no blog' + (id ? ` #${id}` : ''),
    width: '90%',
    height: '90%',
    minHeight: '500px',
    maxHeight: '500px',
    backdrop: true,
    move: false,
    clickOutside: false,
    windowClass: 'erp-window-modern',
    contentClass: '',
    props: {
      id: id
    }
  }, () => import('./Post'))
    .then((wid) => {
      console.log(wid)
      this.$uloc.window.listen(wid, {
        created: (wid, val) => {
          console.log('Created event')
          this.load && this.load()
        }
      })
    }) // return wid
}
